import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs/Subject';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';

import {
  FormModeEnum,
  TableActionParams,
  TableSettings,
  NotificationService,
  ModalService,
  BackendService,
  ToolbarItem,
  TableActionEnum,
  FieldMapItem,
  ToolbarAction,
} from 'beyond-util';

import { SifarnikBase } from '../sifarnici/sifarnik-base/sifarnik-base';
import { BackendService as RtsBackendService } from '../../services/backend.service';
import { MediaPlanService } from '../../services/media-plan.service';
import { EnumService } from '../../services/enum.service';
import { FormCode } from '../../enums/form-code.enum';
import { FormName } from '../../enums/form-name.enum';
import { EndpointTypes } from '../../enums/enpoint-types.enum';
import { FilterType } from '../../enums/filter-type.enum';
import { DEFAULT_DATE_FORMAT } from '../../constants/date-format';
import {
  MEDIA_PLAN_REZERVISI,
  MEDIA_PLAN_OBRISI_IZABRANE,
  MEDIA_PLAN_SPOTOVI,
  MEDIA_PLAN_EMISIJE_PRE_18,
  MEDIA_PLAN_EMISIJE_POSLE_18
} from '../../constants/tooltip-messages';
import { UcestalostEnum } from '../../enums/ucestalost.enum';
import { Observable } from 'rxjs/Observable';
import { UtilServiceClient } from '../../services/util.service';
import { ValidationService } from '../../services/validation.service';
import { of } from 'rxjs/observable/of';
import { SpotEmisija } from './spot-emisija';
import { RasporedBrojRezervacija } from './raspored-broj-rezervacija';
import { RasporedBrojRezervacijaZaSpotEmisija } from './rasporedi-broj-rezervacija-za-spot-emisjia';

@Component({
  selector: 'app-media-plan',
  templateUrl: './media-plan.component.html',
  styleUrls: ['../../pages/media-plan/media-plan.component.scss'],
})
export class MediaPlanComponent extends SifarnikBase
  implements OnInit, OnDestroy {
  private _subscriptions: Array<Subscription> = [];
  private _data: Array<any> = [];

  public spotoviSettingsTable: TableSettings;
  public emisijeSettingsTable: TableSettings;

  public spotoviList: any[];
  public emisijeList: any[];
  public emisijeFilteredList: any[];
  public rasporediList: any[];
  public programi: any[] = [];

  private _rasporediListSource = new Subject<any>();
  public rasporediList$ = this._rasporediListSource.asObservable();

  private rasporediSettingsTable: any;
  private rasporediSettingsTableSource = new Subject<any>();
  public rasporediSettingsTable$ = this.rasporediSettingsTableSource.asObservable();

  private selectRasporediSource = new Subject<any[]>();
  public selectRasporedi$ = this.selectRasporediSource.asObservable();

  private selectEmisijaSource = new Subject<any>();
  public selectEmisija$ = this.selectEmisijaSource.asObservable();

  public ugovorLookupField: FieldMapItem;
  public programComboField: FieldMapItem;
  public klijentLookup: FieldMapItem;
  public datumOdFieldSettings: FieldMapItem;
  public datumDoFieldSettings: FieldMapItem;

  public selectedUgovor: any;
  public selectedPodugovorKlijent: any;
  public selectedRaspored: any;
  public selectedProgram: any;

  public selectedSpot: any;
  public selectedEmisija: any;

  private _deletedRezervacije: any[] = [];

  public rezervacije: any[] = [];
  public rezervacijeDetailsSettingsTable: TableSettings;

  public dnevnoSelected: boolean;
  public nedeljnoSelected: boolean;
  public mesecnoSelected: boolean;
  public vikendiSelected: boolean;
  public radniDaniSelected: boolean;

  public defaultProgramId: any;
  private _klijentZaRezervacije: any;
  public Privilegije: string[] = [];
  public primeniDatumNaRezervacije = false;
  public programFilter = false;
  private _sveRezervacije: any[] = [];
  public hardEditableColumnNames = ['SpotZeljenaPozicija'];
  public prikaziSveSpotove = false;
  private _sviSpotovi: any[] = [];
  private _tipoviUgovora: any[] = [];
  public allRezervacijeSelected = false;
  public ukljuciIzabraniSpot: boolean;
  public brojRezervacijaList: any[] = [];
  public isNewMediaPlan: boolean = false;
  public prikaziEmisijePre18 = false;
  public prikaziEmisijePosle18 = false;

  public rasporediBrojRezervacija: RasporedBrojRezervacijaZaSpotEmisija[] = [];

  get hasKreirajPrivilegija() {
    return this.Privilegije.includes('MSMP_MP_CREATE');
  }

  get hasDeletePrivilegija() {
    return this.Privilegije.includes('MSMP_MP_DELETE');
  }

  get hasEditPrivilegija() {
    return this.Privilegije.includes('MSMP_MP_UPDATE');
  }

  get isSelectedDataValid() {
    return this.selectedEmisija && this.selectedSpot;
  }

  get tipUgovoraId(): any {
    return this.order && this.order.TipUgovoraId
      ? this.order.TipUgovoraId
      : this.selectedPodugovorKlijent.TipUgovoraId;
  }

  private _emisijaFilter: string;

  public showDetails = false;

  public tooltips = {
    MEDIA_PLAN_REZERVISI,
    MEDIA_PLAN_OBRISI_IZABRANE,
    MEDIA_PLAN_SPOTOVI,
    MEDIA_PLAN_EMISIJE_PRE_18,
    MEDIA_PLAN_EMISIJE_POSLE_18
  };

  public Ucestalost = UcestalostEnum;

  public tooltipOptions = {
    placement: 'top',
    'show-delay': '500',
    theme: 'light',
  };

  constructor(
    protected _backendService: BackendService,
    protected _modalService: ModalService,
    protected _notificationService: NotificationService,
    private _rtsBackendService: RtsBackendService,
    private _mediaPlanService: MediaPlanService,
    private _enumService: EnumService,
    private _spinner: NgxSpinnerService,
    private _utilService: UtilServiceClient,
    private _validationService: ValidationService
  ) {
    super(_backendService, _modalService, _notificationService);
  }

  ngOnInit() {
    setTimeout(() => {
      this._spinner.show();
      this.subscribeToTipoviUgovora();
      this.setMediaPlanDetailsSettings();
      this.fetchRezervacijeSettings();
      this.fetchEnums();
      super.ngOnInit();
    });
  }

  onTableActionFilter(event: any) {
    this._spinner.show();
    super.onTableActionFilter(event);
  }

  ngOnDestroy() {
    this._subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }

  subscribeToTipoviUgovora() {
    this._subscriptions.push(
      this._enumService.tipoviUgovora$.subscribe(response => {
        this._tipoviUgovora = response;
      })
    );
  }

  fetchEnums() {
    this._enumService.fetchProgrami();
    this._enumService.fetchStatusUgovora();
    this._enumService.fetchTipoviUgovora();
    this._enumService.registerZeljenePozicije();
    this._enumService.fetchVrsteMedija();
    this._enumService.fetchTipoviPodugovora();
    this.fetchProgramiList();
  }

  fetchProgramiList() {
    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          FormCode.MSPRO_PRO,
          FormName.PregledProgama,
          EndpointTypes.AllEntities
        )
        .subscribe(response => {
          this.programi = response.ServiceData.Data;
        })
    );
  }

  getUgovorPoPaketuTipId() {
    return this._tipoviUgovora.find(t => t.Naziv === 'Ugovor za pakete').Id;
  }

  get ugovorZaSponzorstvoTipId(): any {
    return this._tipoviUgovora.find(t => t.Naziv === 'Ugovor za sponzorstvo')
      .Id;
  }

  deselectRasporedi() {
    const trajanje = this.selectedSpot.TrajanjeSekunde;

    this.rasporediList.forEach(raspored => {
      const deletedRezervacija = this.rezervacije.find(
        sr => sr.EmisijaRasporedId === raspored.Id
      );

      if (deletedRezervacija) {
        raspored.Zauzeto = raspored.Zauzeto - trajanje;
        raspored.Preostalo = raspored.Preostalo + trajanje;
      }
    });

    this.rezervacije = this.filterDeletableRezervacije(this.rasporediList);
    this._sveRezervacije = [...this.rezervacije];
    this.selectAddedRasporedi();
  }

  selectRasporedi(ucestalost: UcestalostEnum) {
    switch (ucestalost) {
      case UcestalostEnum.Dnevno:
        this.toggleByType(
          'dnevnoSelected',
          this.toggleDnevnaUcestalost.bind(this)
        );

        break;
      case UcestalostEnum.Nedeljno:
        this.toggleByType(
          'nedeljnoSelected',
          this.toggleNedeljnaUcestalost.bind(this)
        );

        break;
      case UcestalostEnum.Mesecno:
        this.toggleByType(
          'mesecnoSelected',
          this.toggleMesecnaUcestalost.bind(this)
        );

        break;
      case UcestalostEnum.Vikendi:
        this.toggleByType(
          'vikendiSelected',
          this.toggleUcestalostVikendima.bind(this)
        );

        break;
      case UcestalostEnum.RadniDani:
        this.toggleByType(
          'radniDaniSelected',
          this.toggleUcestalostRadnimDanima.bind(this)
        );

        break;
      default:
        break;
    }
  }

  setUkljuciIzabraniSpot() {
    if (this.selectedSpot) {
      this.ukljuciIzabraniSpot = !this.ukljuciIzabraniSpot;
    } else {
      this.ukljuciIzabraniSpot = false;
      this.notifyError('Potrebno je prvo izabrati spot.');
    }

    this.setRezervacije();
  }

  toggleByType(type: string, callback: Function) {
    if (!this.selectedSpot || !this.selectedEmisija) {
      this._notificationService.notyError(
        'Niste izabrali sve potrebne podatke.'
      );

      setTimeout(() => {
        this[type] = false;
      }, 1000);

      return;
    }

    this[type] = !this[type];
    this.deselectOtherToggles(type);

    let rasporediToAdd: any[] = [];

    if (!this[type]) {
      this.deselectRasporedi();

      return;
    }

    rasporediToAdd = callback();

    if (!this.validate(rasporediToAdd)) {
      setTimeout(() => {
        this[type] = false;
      }, 1000);

      return;
    }

    this.rezervisi(rasporediToAdd);
  }

  deselectOtherToggles(type: string) {
    const types = [
      'dnevnoSelected',
      'nedeljnoSelected',
      'mesecnoSelected',
      'vikendiSelected',
      'radniDaniSelected',
    ];
    types.forEach(t => {
      if (t !== type && this[t]) {
        this[t] = false;
      }
    });
    this.deselectRasporedi();
  }

  toggleDnevnaUcestalost() {
    return this.filterRasporediToAdd();
  }

  toggleNedeljnaUcestalost() {
    return this.filterNedeljnoMesecno(UcestalostEnum.Nedeljno);
  }

  toggleMesecnaUcestalost() {
    return this.filterNedeljnoMesecno(UcestalostEnum.Mesecno);
  }

  toggleUcestalostVikendima() {
    return this.filterRasporediToAdd([0, 6]);
  }

  toggleUcestalostRadnimDanima() {
    return this.filterRasporediToAdd([1, 2, 3, 4, 5]);
  }

  filterRasporediToAdd(days?: number[]): any[] {
    return this.rasporediList.filter(r => {
      const condition = !this.findExistingRezervacija(r);

      return days && days.length
        ? condition && days.includes(moment(r.DatumEmitovanja).day())
        : condition;
    });
  }

  makeDatesArray(ucestalostType: UcestalostEnum) {
    const dates: any[] = [];

    let date = this.order.DatumOd
      ? moment(this.order.DatumOd)
      : moment().startOf('month');

    const datumDo = this.order.DatumDo
      ? moment(this.order.DatumDo).format(DEFAULT_DATE_FORMAT)
      : moment(date)
          .endOf('month')
          .format(DEFAULT_DATE_FORMAT);

    while (date.isBefore(datumDo)) {
      dates.push(date.format('YYYY-MM-DD'));
      date = moment(date).add(
        1,
        ucestalostType === UcestalostEnum.Nedeljno ? 'weeks' : 'month'
      );
    }

    return dates;
  }

  filterNedeljnoMesecno(ucestalostType: UcestalostEnum) {
    const dates = this.makeDatesArray(ucestalostType);

    return this.rasporediList.filter(r => {
      const rezervacija = !this.findExistingRezervacija(r);
      const includesDate = dates.includes(
        moment(r.DatumEmitovanja).format('YYYY-MM-DD')
      );

      return rezervacija && includesDate;
    });
  }

  checkDnevno() {
    this.dnevnoSelected = this.rasporediList.every(r => {
      return this.findExistingRezervacija(r);
    });
  }

  checkDani(days) {
    const nothingSelected = this.rasporediList.every(r => {
      return !this.findExistingRezervacija(r);
    });

    if (nothingSelected) {
      return false;
    }

    return this.rasporediList.every(r => {
      const rezervacija = this.findExistingRezervacija(r);
      const includesDate = days.includes(moment(r.DatumEmitovanja).day());

      return rezervacija && days && days.length
        ? includesDate && includesDate
        : !includesDate;
    });
  }

  checkNedeljnoMesecno(ucestalostType: UcestalostEnum) {
    const dates = this.makeDatesArray(ucestalostType);

    if (!dates || !dates.length) {
      return false;
    }

    const nothingSelected = this.rasporediList.every(r => {
      return !this.findExistingRezervacija(r);
    });

    if (nothingSelected) {
      return false;
    }

    return this.rasporediList.every(r => {
      const rezervacija = this.findExistingRezervacija(r);
      const includesDate = dates.includes(
        moment(r.DatumEmitovanja).format('YYYY-MM-DD')
      );

      return rezervacija && dates && dates.length
        ? rezervacija && includesDate
        : rezervacija
        ? includesDate
        : !includesDate;
    });
  }

  filterRezervacije(type: FilterType) {
    switch (type) {
      case FilterType.Datum:
        this.primeniDatumNaRezervacije = !this.primeniDatumNaRezervacije;
        break;
      case FilterType.Program:
        this.programFilter = !this.programFilter;
        break;
      default:
        break;
    }

    this.setRezervacije();
  }

  setInitKlijentiNaUgovoruFilter() {
    this.ugovorLookupField.lookupInitFilter = [
      { name: 'klijentiNaUgovoru', value: 'true' },
      { name: 'jeNewMediaPlan', value: 'true'},
    ];
  }

  // setInitKlijentiFilter() {
  //   this.klijentLookup.lookupInitFilter = [
  //     { name: 'jeNewMediaPlan', value: 'true'},
  //   ];
  // }

  setMediaPlanDetailsSettings() {
    const mediaPlanSettings = this._mediaPlanService.getMediaPlanUgovorSettings();
    const mediaPlanSettingsTable = new TableSettings(
      mediaPlanSettings,
      'table'
    );

    this.ugovorLookupField = mediaPlanSettingsTable.getFieldByName('Ugovor');
    this.programComboField = mediaPlanSettingsTable.getFieldByName('Program');

    this.klijentLookup = mediaPlanSettingsTable.getFieldByName('Klijent');
    this.datumOdFieldSettings = mediaPlanSettingsTable.getFieldByName(
      'DatumOd'
    );
    this.datumDoFieldSettings = mediaPlanSettingsTable.getFieldByName(
      'DatumDo'
    );
  }

  changeName() {
    if (typeof this.order === 'undefined') {
      return;
    }

    if (this.order.hasOwnProperty('naziv')) {
      this.name = this.order.naziv;
    } else if (this.mode === FormModeEnum.Add) {
      this.name = 'Novi media plan';
    } else if (this.order.hasOwnProperty('id')) {
      this.name = 'Media plan';
    }
  }

  loadSettings() {
    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSMP_MP,
      FormName.MediaPlan,
      EndpointTypes.GetAllEntities,
      this.filterQuery
    );

    this._subscriptions.push(
      this._rtsBackendService
        .fetchMediaPlanSettings(payload)
        .subscribe((data: any) => {
          this._spinner.hide();
          if (!this.settingsTable) {
            const settings = this.alterSettings(data);
            this.setSettings(settings);
          }

          this._data = data.ServiceData.Data;
          this._dataCount = data.ServiceData.DataSumCount;

          this.setAllFields();
          this.refreshTable();
          this.changeMode(FormModeEnum.Table);
          this.Privilegije = data.Privilegije;
        })
    );
  }

  onEditMode() {
    if (this.programi && this.programi.length) {
      super.onEditMode();
    }
  }

  fetchRezervacijeSettings() {
    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSMP_REZ,
      FormName.MediaPlan,
      EndpointTypes.GetModelData
    );

    this._subscriptions.push(
      this._rtsBackendService
        .fetchMediaPlanSettings(payload)
        .subscribe(data => {
          this._spinner.hide();
          const rezervacijeDetailsSettings = this.alterDetailsSettings(data);
          this.setRezervacijeDetailsSettings(rezervacijeDetailsSettings);
        })
    );
  }

  alterSettings(data: any) {
    const settings = { ...data.Settings };

    settings.inlineEditing = false;
    settings.inlineAdding = false;
    settings.additable = false;
    settings.deletable = false;

    return settings;
  }

  alterDetailsSettings(data: any) {
    const settings = { ...data.Settings };

    settings.allFields.forEach(field => {
      field.editable = false;
    });

    settings.inlineAdding = false;
    settings.additable = false;

    return settings;
  }

  setRezervacijeDetailsSettings(settings: any) {
    const rezervacijeTableFields = [
      'SpotNaziv',
      'SpotTrajanje',
      'SpotZeljenaPozicija',
      'EmisijaNaziv',
      'ProgramNaziv',
      'DatumEmitovanja',
      'VremeEmitovanja',
    ];

    const allTableFields = settings.allFields.filter(field => {
      return rezervacijeTableFields.includes(field.name);
    });

    settings.formSettings.table = allTableFields.map(field => field.id);

    this.rezervacijeDetailsSettingsTable = new TableSettings(settings, 'table');
    this.rezervacijeDetailsSettingsTable.inlineEditing = false;
  }

  setSpotoviSettings(data) {
    const spotoviTableFields = [
      'Sifra',
      'Naziv',
      'TrajanjeSekunde',
      'ZeljenaPozicija',
      'BrojRezervacija',
      'BrojEmisija',
    ];

    const spotoviNames = [
      'Šifra',
      'Naziv',
      'Trajanje',
      'Željena pozicija',
      'Rezervacije',
      'Emisije',
    ];

    const spotWidths = [20, 30, 5, 5, 5, 5];

    const spotoviSettingsData = this.alterDetailsTableSettings(
      data,
      spotoviTableFields,
      spotoviNames,
      0,
      spotWidths
    );
    this.spotoviSettingsTable = new TableSettings(spotoviSettingsData, 'table');
  }

  setDetailsSettings(data) {
    this.setSpotoviSettings(data);

    const emisijeTableFields = ['Naziv', 'VremeEmitovanja', 'BrojSpotova'];
    const emisijeNames = ['Naziv', 'Vreme', 'Br. spotova'];
    const emisijeWidths = [40, 5, 5];
    const emisijeSettingsData = this.alterDetailsTableSettings(
      data,
      emisijeTableFields,
      emisijeNames,
      1,
      emisijeWidths
    );
    this.emisijeSettingsTable = new TableSettings(emisijeSettingsData, 'table');

    const rasporediTableFields = [
      'DatumEmitovanja',
      'VremeEmitovanja',
      // 'Trajanje',
      'Preostalo',
      'Zauzeto',
      'BrojRezervacija',
      // 'Status',
    ];
    const rasporediNames = [
      'Datum',
      'Vreme',
      //  'Trajanje',
      'Preostalo',
      'Zauzeto',
      'Br rezervacija',
      // 'Status',
    ];
    const rasporediWidths = [40, 10, 5, 5, 5];
    const rasporediSettingsData = this.alterDetailsTableSettings(
      data,
      rasporediTableFields,
      rasporediNames,
      2,
      rasporediWidths
    );
    const rasporediSettingsTable = new TableSettings(
      rasporediSettingsData,
      'table'
    );
    this.rasporediSettingsTable = rasporediSettingsTable;
  }

  alterDetailsTableSettings(
    data: any,
    tableFields: Array<any>,
    names: Array<string>,
    index: number,
    widths: Array<number>
  ) {
    const settings = data.Settings.details[index];
    // if (index === 2) {
    //   settings.allFields.push(
    //     this._mediaPlanService.getBrojRezervacijaSettings()
    //   );
    // }

    const allTableFields = settings.allFields.filter(field => {
      return tableFields.includes(field.name);
    });

    allTableFields.forEach((element, i) => {
      element.label = names[i];
      element.width = widths[i];
    });

    settings.formSettings.table = allTableFields.map(field => field.id);

    return settings;
  }

  refreshTable() {
    this.setRbr(this._data);
    this.setId(this._data);

    this.orderListCount = this._dataCount;
    this.orderList = this._data;

    let currentDate = new Date().getTime();
    for(let i = 0; i < this.orderList.length; i++) {
      let datumDo = new Date(moment(this.orderList[i].DatumDo).format(DEFAULT_DATE_FORMAT)).getTime();
      if(datumDo >= currentDate) {
          this.orderList[i].color = 'success';
      }
    }
  }

  refreshTableByType(collection: Array<any>, type: string) {
    if (collection.length) {
      this.setId(collection);
    }

    this[`${type}List`] = collection;

    if (type === 'rasporedi') {
      this.rasporediList = collection;
      this.rasporediSettingsTableSource.next(this.rasporediSettingsTable);
      this._rasporediListSource.next(this.rasporediList);
    }
  }

  onTableActionView() {
    this._spinner.show();
    this.selectedEmisija = null;
    this.dnevnoSelected = false;
    this.resetFilter();

    this.selectedUgovor = {
      UgovorId: this.order.UgovorId,
    };

    this.selectedPodugovorKlijent = {
      KupacId: this.order.KupacId,
    };

    this.fetchMediaPlanSettings(FormModeEnum.Edit);

    const entityGuids = {
      UgovorId: this.order.UgovorId,
      KupacId: this.order.KupacId,
      PodugovorId: this.order.PodugovorId,
    };

    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSMP_MP,
      FormName.MediaPlan,
      EndpointTypes.GetSingleEntity,
      null,
      null,
      entityGuids
    );

    this._subscriptions.push(
      this._rtsBackendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          this._sveRezervacije = response.ServiceData.Rezervacije;
          const tipId = response.ServiceData.TipPodugovoraId;
          const podugovorId = response.ServiceData.PodugovorId;
          const nacinObracunaId = response.ServiceData.NacinObracunaId;

          // if (this._sveRezervacije.length === 0) {
          //   this._spinner.hide();
          //   this._notificationService.notyError(
          //     `Media plan sa brojem ugovora ${response.ServiceData.BrojUgovora} i brojem podugovora ${response.ServiceData.BrojPodugovora} trenutno sadrži samo brendirane špice i nije ga moguće otvoriti. Rezervacije na ovom media planu možete videti na formi "Pregled rezervacija".`
          //   );
          //   this.onClose();
          // }

          this.setRezervacije({
            datumOd: response.ServiceData.DatumOd,
            datumDo: response.ServiceData.DatumDo,
          });

          this.selectedProgram = this.programi[0].Id;
          const vrstaMedijaId = this._enumService.programi.find(
            x => x.Id === this.selectedProgram
          ).VrstaMedijaId;

          this.fetchMediaPlanData(
            response.ServiceData,
            response.ServiceData.Spotovi,
            vrstaMedijaId,
            podugovorId
          );

          if (tipId === this.ugovorZaSponzorstvoTipId) {
            this.getEmisijePodugovor(podugovorId).subscribe(e => {
              this.selectedPodugovorKlijent = {
                PodugovorId: podugovorId,
                TipUgovoraId: tipId,
                BrojPlaniranihRezervacija:
                  response.ServiceData.PlaniraniBrojRezervacija,
                Spotovi: response.ServiceData.Spotovi,  
                Emisije: e.ServiceData,
              };
            });
          } else {
            this.selectedPodugovorKlijent = {
              PodugovorId: podugovorId,
              TipUgovoraId: tipId,
              NacinObracunaId: nacinObracunaId,
              Spotovi: response.ServiceData.Spotovi,
              BrojPlaniranihRezervacija:
                response.ServiceData.PlaniraniBrojRezervacija,
            };
          }

          this._mediaPlanService.setProgram(this.selectedProgram);

          const privilegije = response.Privilegije;
          this.Privilegije = privilegije;
          const toolbarItems: ToolbarItem[] = [];

          if (privilegije.includes('MSMP_MP_UPDATE')) {
            toolbarItems.push(
              ToolbarItem.ItemSave(
                true,
                true,
                'Dugme "Sačuvaj" služi za čuvanje podataka o Media planu.'
              )
            );
          }

          if (
            privilegije.includes('MSMP_MP_DELETE') &&
            this.sveRezervacijeSuSlobodne()
          ) {
            toolbarItems.push(ToolbarItem.ItemDelete());
          }

          this.setToolbarOptions({
            toolbarVisible: true,
            items: toolbarItems,
            closeTooltip: 'Dugme "X" služi za poništavanje unosa.',
          });
          this.showDetails = true;
        })
    );
  }

  sveRezervacijeSuSlobodne() {
    return this._sveRezervacije.every(r => r.Status === 0);
  }

  setSpotRezervacijeEmisije(podugovorId: string) {
    if (!this._sviSpotovi.length) {
      return;
    }

    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSMP_SPCOUNT,
      FormName.MediaPlan,
      EndpointTypes.PostEntity,
      `?podugovorId=${podugovorId}`,
      this._sviSpotovi.map(s => s.Id),
      null,
      true
    );

    this._rtsBackendService
      .fetchMediaPlanSettings(payload)
      .subscribe((response: any) => {
        this._sviSpotovi.forEach(x => {
          const spot = response.ServiceData.find(y => y.SpotId === x.Id);
          x.BrojRezervacija = spot.BrojRezervacija;
          x.BrojEmisija = spot.BrojEmisija;
        });
      });
  }

  setBrSpotovaNaEmisiji() {
    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSMP_SPEMICOUNT,
      FormName.MediaPlan,
      EndpointTypes.PostEntity,
      `?podugovorId=${this.selectedPodugovorKlijent.PodugovorId}`,
      this.emisijeList.map(x => x.Id),
      null,
      true
    );

    this._rtsBackendService
      .fetchMediaPlanSettings(payload)
      .subscribe((response: any) => {
        let emisijeIds: any[] = [];
        if (
          this.selectedPodugovorKlijent &&
          this.selectedPodugovorKlijent.Emisije
        ) {
          emisijeIds = this.selectedPodugovorKlijent.Emisije.map(
            e => e.EmisijaId
          );
        }
        this.emisijeList.forEach(x => {
          x.BrojSpotova = response.ServiceData.find(
            y => y.EmisijaId === x.Id
          ).BrojSpotova;

          if (this.tipUgovoraId === this.ugovorZaSponzorstvoTipId) {
            if (emisijeIds.length > 0) {
              x.NijeNaUgovoru = !emisijeIds.includes(x.Id);
            } else {
              x.NijeNaUgovoru = true;
            }
          } else {
            delete x.NijeNaUgovoru;
          }
        });
      });
  }

  setRezervacije(onPregledEvent?) {
    this.filterBy(onPregledEvent);
    this.setColorForRezervacijeInMontaza();
    this.setRbr(this.rezervacije);
  }

  filterBy(onPregledEvent?: any) {
    const dOd = onPregledEvent ? onPregledEvent.datumOd : this.order.DatumOd;
    const dDo = onPregledEvent ? onPregledEvent.datumDo : this.order.DatumDo;
    let filterRez = [...this._sveRezervacije];

    if (this.primeniDatumNaRezervacije) {
      filterRez = this.rezervacijaFilterByDateRange(filterRez, dOd, dDo);
    }

    if (this.programFilter) {
      filterRez = this.rezervacijaFilterByProgram(filterRez);
    }

    if (this.ukljuciIzabraniSpot) {
      filterRez = this.rezervacijaFilterByIzabraniSpot(filterRez);
    }

    filterRez = this.rezervacijeFilterDeleted(filterRez);

    this.rezervacije = [...filterRez];
  }

  rezervacijeFilterDeleted(rezervacije: any[]) {
    return rezervacije.filter(r => !r.Deleted);
  }

  rezervacijaFilterByProgram(rezervacije: any[]): any[] {
    return rezervacije.filter(r => r.ProgramId === this.selectedProgram.Id);
  }

  rezervacijaFilterByIzabraniSpot(rezervacije: any[]): any[] {
    return rezervacije.filter(r => r.SpotId === this.selectedSpot.Id);
  }

  rezervacijaFilterByDateRange(
    rezervacije: any[],
    datumOd: any,
    datumDo: any
  ): any[] {
    return rezervacije.filter(r => {
      const datem = moment(r.DatumEmitovanja);

      return datem.diff(datumOd) >= 0 && datem.diff(datumDo) <= 0;
    });
  }

  setColorForRezervacijeInMontaza() {
    this.rezervacije.forEach(r => {
      switch (r.Status) {
        case 1:
          r.color = 'warning';
          break;
        case 2:
          r.color = 'danger';
          break;
        case 3:
          r.color = 'verified';
          break;
        case 4:
          r.color = 'info';
          break;
      }
    });
  }

  spotoviTableAction(event) {
    if (event.action === TableActionEnum.Select) {
      this.setSpotColor(this.spotoviList);
      this.selectedSpot = { ...event.document };

      if (this.selectedSpot.JeIstekao) {
        const index = this.spotoviList.findIndex(
          s => s.Id === this.selectedSpot.Id
        );
        this.spotoviList[index].color = '';
      }
      this.checkToggles();
      if (this.selectedEmisija && this.selectedSpot) {
        this.checkSpotEmisijaExistenceOrFetchData({
          SpotId: this.selectedSpot.Id,
          EmisijaId: this.selectedEmisija.Id,
        });
      }
    }
  }

  rasporediTableAction(event) {
    if (event.action === TableActionEnum.Click) {
      this.selectedRaspored = event.document;

      if (
        !event.multiselect &&
        this.izbaciIzRezervacije(this.selectedRaspored)
      ) {
        this.checkToggles();

        return;
      }

      if (!this.validate([this.selectedRaspored])) {
        return;
      }

      this.rezervisi([this.selectedRaspored]);

      if (!event.multiselect) {
        this.checkToggles();
      }
    }
  }

  emisijeTableAction(event) {
    if (event.action === TableActionEnum.Select) {
      const rasporedi = [...event.document.Rasporedi];

      this.calculatePreostalo(rasporedi);
      this.refreshTableByType(rasporedi, 'rasporedi');
      this.selectedEmisija = { ...event.document };
      this.selectedRaspored = null;

      this.selectRasporediSource.next([]);

      if (this.selectedSpot) {
        this.checkToggles();
      }

      if (this.selectedEmisija && this.selectedSpot) {
        this.checkSpotEmisijaExistenceOrFetchData({
          SpotId: this.selectedSpot.Id,
          EmisijaId: this.selectedEmisija.Id,
        });
      }
      // this.selectAddedRasporedi();
    }
  }

  checkToggles() {
    this.checkDnevno();

    if (!this.dnevnoSelected) {
      this.radniDaniSelected = this.checkDani([1, 2, 3, 4, 5]);
    }

    if (!this.radniDaniSelected) {
      this.vikendiSelected = this.checkDani([0, 6]);
    }

    if (!this.vikendiSelected) {
      this.nedeljnoSelected = this.checkNedeljnoMesecno(
        UcestalostEnum.Nedeljno
      );
    }

    if (!this.nedeljnoSelected) {
      this.mesecnoSelected = this.checkNedeljnoMesecno(UcestalostEnum.Mesecno);
    }
  }

  // provera da li postoji neka kombinacija spot/emisija u inicijalnoj listi rasporeda sa brojevima rezervacija.
  rasporediBrojRezervacijaListHasKeyAndValues(key: SpotEmisija): boolean {
    return this.rasporediBrojRezervacija.some(
      f =>
        f.SpotEmisija.SpotId === key.SpotId &&
        f.SpotEmisija.EmisijaId === key.EmisijaId
    );
  }

  // uzima iz liste rasporeda sa brojevima rezervacija, rasporede za kljuc spot-emisija.
  rasporedBrojRezervacijaGetValues(
    key: SpotEmisija
  ): RasporedBrojRezervacija[] {
    const rasp = this.rasporediBrojRezervacija.find(
      f =>
        f.SpotEmisija.SpotId === key.SpotId &&
        f.SpotEmisija.EmisijaId === key.EmisijaId
    );

    // && rasp.RasporediBrojRezervacija.length > 0
    return rasp.RasporediBrojRezervacija;
    // rasp && rasp.RasporediBrojRezervacija
    //   ? rasp.RasporediBrojRezervacija
    //   : [];
  }

  // dodaje u listu rasporeda sa rezervacijama za kljuc spot emisija ukoliko kljuc ne postoji i vrednost za kljuc postoji.
  rasporedBrojRezervacijaAddToList(
    key: SpotEmisija,
    value: RasporedBrojRezervacija[]
  ) {
    if (
      !this.rasporediBrojRezervacijaListHasKeyAndValues(key) // && value.length > 0
    ) {
      this.rasporediBrojRezervacija.push({
        SpotEmisija: key,
        RasporediBrojRezervacija: value,
      });
    }
  }

  // selektuje dodate rasporede ili deselektuje rasporede u zavisnosti od klika na rasporedu.
  selectAddedRasporedi(isfilter: boolean = false) {
    if (this.selectedEmisija && this.selectedSpot) {
      const key = {
        SpotId: this.selectedSpot.Id,
        EmisijaId: this.selectedEmisija.Id,
      };
      this.rasporediList.forEach(r => {
        const rezervacije: any[] = this.findSelectedRezervacija(r);

        if (this.rasporediBrojRezervacijaListHasKeyAndValues(key)) {
          const rasporediRezervacijeCount = this.rasporedBrojRezervacijaGetValues(
            key
          );

          const count = rasporediRezervacijeCount.find(
            rasporedCount => rasporedCount.Key === r.Id
          );

          if (count) {
            r.color = 'success';
            r.BrojRezervacija = count.Value + rezervacije.length;
          } else {
            r.color = rezervacije.length > 0 ? 'success' : '';
            r.BrojRezervacija = rezervacije.length;
          }
        } else {
          r.color = rezervacije.length > 0 ? 'success' : '';
          r.BrojRezervacija = rezervacije.length;
        }
      });

      this._rasporediListSource.next(this.rasporediList);
    } else {
      this.rasporediList.forEach(r => (r.color = null));
      this._rasporediListSource.next(
        this.selectedEmisija ? this.selectedEmisija.Rasporedi : []
      );
    }
  }

  fetchBrojRezervacija(spotEmisja: SpotEmisija) {
    const kupacId = `KupacId=${
      this.selectedUgovor.KupacId
        ? this.selectedUgovor.KupacId
        : this.selectedUgovor.Klijent.Id
    }`;
    const ugovorId = `UgovorId=${
      this.selectedUgovor.UgovorId
        ? this.selectedUgovor.UgovorId
        : this.selectedUgovor.Id
    }`;
    const podugovorId = `PodugovorId=${this.selectedPodugovorKlijent.PodugovorId}`;
    const datumOd = `DatumOd=${this.order.DatumOd}`;
    const datumDo = `DatumDo=${this.order.DatumDo}`;
    const programId = `ProgramId=${this.selectedProgram.Id}`;
    const spotId = `SpotId=${spotEmisja.SpotId}`;
    const emisijaId = `EmisijaId=${spotEmisja.EmisijaId}`;

    const filter = `?${kupacId}&${ugovorId}&${podugovorId}&${datumOd}&${datumDo}&${programId}&${spotId}&${emisijaId}`;

    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSMP_GRR,
      FormName.MediaPlan,
      EndpointTypes.GetAllEntities,
      filter,
      null,
      null,
      true
    );

    this._subscriptions.push(
      this._rtsBackendService
        .fetchMediaPlanSettings(payload)
        .subscribe((result: any) => {
          const rasporedBrojRezervacija = result.ServiceData
            .EmisijaRasporediBrojRezervacija as RasporedBrojRezervacija[];
          this.rasporedBrojRezervacijaAddToList(
            spotEmisja,
            rasporedBrojRezervacija
          );
          this.mapBrojRezervacijaNaRasporede(rasporedBrojRezervacija);
        })
    );
  }

  // proverava da li postoje podaci brojeva rezervacija za rasporede (po filteru spot/emisija) ako postoje samo uzme vrednost koju je sacuvao i namapira na raspored
  // ukoliko ne postoje zove servis da dobavi podatke i cuva ih listu inicijalnih vrednosti.

  // Privremeno sklonjeno kesiranje.
  checkSpotEmisijaExistenceOrFetchData(key: SpotEmisija) {
    // if (this.rasporediBrojRezervacijaListHasKeyAndValues(key)) {
    //   const rasporedBrRez = this.rasporedBrojRezervacijaGetValues(key);
    //   this.mapBrojRezervacijaNaRasporede(rasporedBrRez);
    // } else {
    this.fetchBrojRezervacija(key);
    // }
  }

  mapBrojRezervacijaNaRasporede(
    rasporediBrojRezervacija: RasporedBrojRezervacija[]
  ) {
    this.rasporediList.forEach(raspored => {
      const found = rasporediBrojRezervacija.find(r => raspored.Id === r.Key);
      const rezervacijaFound = this.rezervacije.filter(
        r =>
          r.EmisijaRasporedId === raspored.Id &&
          r.SpotId === this.selectedSpot.Id
      );

      if (found) {
        raspored.color = 'success';
        raspored.BrojRezervacija = found.Value;
      } else {
        raspored.color = '';
        raspored.BrojRezervacija = 0;
      }

      if (rezervacijaFound && rezervacijaFound.length) {
        raspored.color = 'success';
        raspored.BrojRezervacija += rezervacijaFound.length;
      }
    });

    this._rasporediListSource.next(this.rasporediList);
  }

  findSelectedRezervacija(raspored: any) {
    return this.rezervacije.filter(rezervacija => {
      return (
        rezervacija.EmisijaRasporedId === raspored.Id &&
        rezervacija.SpotId === this.selectedSpot.Id &&
        rezervacija.EmisijaId === this.selectedEmisija.Id
      );
    });
  }

  calculatePreostalo(rasporedi: any[]) {
    rasporedi.forEach(raspored => {
      if (raspored.Trajanje) {
        const index = this._deletedRezervacije.findIndex(
          rezervacija => rezervacija.RasporedId === raspored.Id
        );

        if (index !== -1) {
          raspored.Preostalo =
            raspored.Preostalo + this._deletedRezervacije[index].Trajanje;
          this._deletedRezervacije.splice(index, 1);
        }
      }
    });
  }

  validate(rasporedi: any[]) {
    if (!this.validateRezervisi()) {
      this._notificationService.notyError(
        'Niste izabrali sve potrebne podatke.'
      );

      return false;
    }

    if (!this.validateDatumiSpota(rasporedi)) {
      this._notificationService.notyError(
        'Nije moguće kreirati rezervaciju pošto je datum odjave spota u odnosu na datum emitovanja emisije istekao.'
      );

      return false;
    }

    if (!this.validateDatumIstekaUgovora(rasporedi, this.selectedUgovor['DatumIstekaUgovora'] ? this.selectedUgovor.DatumIstekaUgovora : this.selectedUgovor.DatumIsteka)) {
      this._notificationService.notyError(
        'Nije moguće kreirati rezervaciju pošto je datum isteka ugovora u odnosu na datum emitovanja emisije istekao.'
      );

      return false;
    }

    if (!this.validateDatumIstekaUgovora(rasporedi, this.selectedUgovor['DatumIstekaPodugovora'] ? this.selectedUgovor.DatumIstekaPodugovora : this.selectedPodugovorKlijent.DatumIsteka)) {
      this._notificationService.notyError(
        'Nije moguće kreirati rezervaciju pošto je datum isteka podugovora u odnosu na datum emitovanja emisije istekao.'
      );

      return false;
    }

    if (
      !this._validationService.validateZabrane(this.selectedSpot, rasporedi)
    ) {
      this._notificationService.notyError(
        'Nije moguće napraviti rezervaciju za dati spot u zadatom terminu zbog prisustva zabrane na spotu.'
      );

      return false;
    }

    if (this.validateUgovorZaSponzorstvo()) {
      this._notificationService.notyError(
        `Nije moguće napraviti rezervaciju. Vrsta spota nije 'Reklama + logo', a izabrana emisija nije definisana na ugovoru.`
      );

      return false;
    }

    if (this.validateBrojPlaniranihRezervacija()) {
      this._notificationService.notyError(
        `Nije moguće napraviti rezervaciju, već je dodat maksimalan broj planiranih rezervacija (${this.selectedPodugovorKlijent.BrojPlaniranihRezervacija}).`
      );

      return false;
    }

    return true;
  }

  validateUgovorZaSponzorstvo() {
    return (
      this.selectedSpot &&
      this.selectedEmisija &&
      this.selectedSpot.VrstaSpotaId !== 14 && // 3 === Reklama + logo
      this.selectedEmisija.NijeNaUgovoru &&
      this.tipUgovoraId === this.ugovorZaSponzorstvoTipId
    );
  }

  validateBrojPlaniranihRezervacija() {
    return (
      this.selectedPodugovorKlijent &&
      this.selectedPodugovorKlijent.TipUgovoraId ===
        this.getUgovorPoPaketuTipId() &&
      this.selectedPodugovorKlijent.BrojPlaniranihRezervacija &&
      this.selectedPodugovorKlijent.BrojPlaniranihRezervacija <=
        this.rezervacije.length
    );
  }

  izbaciIzRezervacije(raspored) {
    const foundRezervacijaIndex = this.findExistingRezervacijaIndex(raspored);
    const deletableRezervacijaIndex = this.findDeletableRezervacijaIndex(
      raspored
    );

    if (deletableRezervacijaIndex !== -1) {
      const rezervacijaIndex = this._sveRezervacije.findIndex(
        r =>
          r.EmisijaRasporedId === raspored.Id &&
          r.SpotId === this.selectedSpot.Id
      );
      this._sveRezervacije.splice(rezervacijaIndex, 1);
      // if (rezervacija) {
      //   rezervacija.Deleted = true;
      // }

      const deletedRezervacije = this.rezervacije.splice(
        deletableRezervacijaIndex,
        1
      );
      this.rezervacije = [...this.rezervacije];

      const trajanje = this.selectedSpot.TrajanjeSekunde;

      raspored.Zauzeto = raspored.Zauzeto - trajanje;
      raspored.Preostalo = raspored.Preostalo + trajanje;

      this.dnevnoSelected = false;
      this.selectAddedRasporedi();

      return true;
    } else if (foundRezervacijaIndex !== -1) {
      return true;
    }

    return false;
  }

  rezervisi(rasporedi: any[]) {
    let newRezervacije = [];
    rasporedi = this.filterRezervacijeToAddByDateAndProgram(rasporedi);

    rasporedi.forEach(r => {
      const rezervacijeToAdd = this._mediaPlanService.getRezervacije(
        r,
        this.selectedUgovor,
        this.selectedEmisija,
        this.selectedSpot,
        this.rezervacije,
        this._klijentZaRezervacije,
        this.selectedProgram
      );

      newRezervacije = [...newRezervacije, ...rezervacijeToAdd];
    });

    this.rezervacije = [...this.rezervacije, ...newRezervacije];
    this._sveRezervacije = [...this._sveRezervacije, ...newRezervacije];

    this.subZauzetoIPreostaloVreme(rasporedi);
    this.selectAddedRasporedi();
  }

  public getKlijentFromObjects(lookupProperty, order) {
    if (
      lookupProperty.hasOwnProperty('KupacNaziv') &&
      lookupProperty.hasOwnProperty('KupacNaziv') &&
      lookupProperty.hasOwnProperty('PodugovorId')
    ) {
      return {
        Id: lookupProperty.KupacId,
        Naziv: lookupProperty.KupacNaziv,
        PodugovorId: lookupProperty.PodugovorId,
        BrojPodugovora: lookupProperty.BrojPodugovora,
      };
    } else if (
      lookupProperty.hasOwnProperty('KlijentId') &&
      lookupProperty.hasOwnProperty('KlijentNaziv') &&
      lookupProperty.hasOwnProperty('PodugovorId')
    ) {
      return {
        Id: lookupProperty.KlijentId,
        Naziv: lookupProperty.KlijentNaziv,
        PodugovorId: lookupProperty.PodugovorId,
        BrojPodugovora: lookupProperty.BrojPodugovora,
      };
    }

    if (
      order.hasOwnProperty('KupacId') &&
      order.hasOwnProperty('KupacNaziv') &&
      order.hasOwnProperty('PodugovorId')
    ) {
      return {
        Id: order.KupacId,
        Naziv: order.KupacNaziv,
        PodugovorId: order.PodugovorId,
        BrojPodugovora: order.BrojPodugovora,
      };
    }
  }

  setSelectedColor(array: any[]) {
    array.forEach(e => (e.color = 'success'));
  }

  onAllSelected(allSelected: any) {
    this.allRezervacijeSelected = allSelected;
    this.rezervacije
      .filter(x => x.Status !== 2 && x.Status !== 4)
      .forEach(r => (r.selected = allSelected));
  }

  onRowSelected(selected: any) {
    if (
      this.allRezervacijeSelected &&
      selected !== this.allRezervacijeSelected
    ) {
      this.allRezervacijeSelected = !this.allRezervacijeSelected;
    }
  }

  findExistingRezervacija(raspored: any) {
    if (!this.selectedSpot || !this.selectedEmisija) {
      return false;
    }

    const rezervacije = this.rezervacije.filter(rezervacija => {
      return (
        rezervacija.EmisijaRasporedId === raspored.Id &&
        rezervacija.SpotId === this.selectedSpot.Id &&
        rezervacija.EmisijaId === this.selectedEmisija.Id
      );
    });

    return !!rezervacije.length;
  }

  filterExistingRezervacije(rasporedi: any) {
    const rasporedIds = rasporedi.map(r => r.Id);

    return this.rezervacije.filter(rezervacija => {
      return !(
        rasporedIds.includes(rezervacija.EmisijaRasporedId) &&
        rezervacija.SpotId === this.selectedSpot.Id &&
        rezervacija.EmisijaId === this.selectedEmisija.Id
      );
    });
  }

  filterDeletableRezervacije(rasporedi: any) {
    const rasporedIds = rasporedi.map(r => r.Id);

    return this.rezervacije.filter(rezervacija => {
      return !(
        rasporedIds.includes(rezervacija.EmisijaRasporedId) &&
        rezervacija.SpotId === this.selectedSpot.Id &&
        rezervacija.EmisijaId === this.selectedEmisija.Id &&
        rezervacija.Status !== 2 &&
        rezervacija.Status !== 4
      );
    });
  }

  findExistingRezervacijaIndex(raspored: any) {
    return this.rezervacije.findIndex(rezervacija => {
      return (
        rezervacija.EmisijaRasporedId === raspored.Id &&
        rezervacija.SpotId === this.selectedSpot.Id &&
        rezervacija.Status !== 0
      );
    });
  }

  findDeletableRezervacijaIndex(raspored: any) {
    return this.rezervacije.findIndex(rezervacija => {
      return (
        rezervacija.EmisijaRasporedId === raspored.Id &&
        rezervacija.SpotId === this.selectedSpot.Id &&
        rezervacija.Status !== 2 &&
        // TODO Dodati status 3
        rezervacija.Status !== 3 &&
        rezervacija.Status !== 4
      );
    });
  }

  subZauzetoIPreostaloVreme(rasporedi: any[]) {
    rasporedi.forEach(raspored => {
      if (raspored.Trajanje) {
        raspored.Zauzeto = raspored.Zauzeto + this.selectedSpot.TrajanjeSekunde;
        raspored.Preostalo =
          raspored.Preostalo - this.selectedSpot.TrajanjeSekunde;
      }
    });
  }

  validateDatumiSpota(rasporedi: any[]): boolean {
    return rasporedi.every(r =>
      moment(this.selectedSpot.DatumOdjave).isSameOrAfter(
        moment(r.DatumEmitovanja)
      )
    );
  }

  validateDatumIstekaUgovora(rasporedi: any[], datumIsteka: any): boolean {
    return rasporedi.every(r =>
      moment(datumIsteka).isSameOrAfter(moment(r.DatumEmitovanja))
    );
  }

  validateRezervisi() {
    return this.selectedUgovor && this.selectedEmisija && this.selectedSpot;
  }

  onDelete(event, callback, message = this.getBrisanjeMPMessage()) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this._modalService.openModal(message, response => {
      if (response) {
        callback();
      }
    });
  }

  getBrisanjeMPMessage() {
    return `Izborom akcije Obriši izvršiće se brisanje kompletnog media plana za ugovor ${
      this.selectedUgovor.BrojUgovora
    } i podugovor: ${this.order.BrojPodugovora}, za ceo period od ${moment(
      this.order.DatumOd
    ).format(DEFAULT_DATE_FORMAT)} do ${moment(this.order.DatumDo).format(
      DEFAULT_DATE_FORMAT
    )}. Oporavak od ove akcije nije moguć! Da li želite da nastavite?`;
  }

  onDeleteConfirm() {
    this._spinner.show();
    this.canDeleteMediaPlan().subscribe(response => {
      const res = response.ServiceData;
      if (res) {
        this._modalService.openModal(
          `Opredelili ste se za brisanje media plana. Oporavak od ove akcije nije moguć! Da li želite da nastavite?`,
          toDelete => {
            if (toDelete) {
              const entityGuids = {
                KupacId: this.selectedUgovor.KupacId,
                UgovorId: this.selectedUgovor.UgovorId,
                PodugovorId: this.order.PodugovorId,
              };

              const payload = this._rtsBackendService.getRequestPayload(
                FormCode.MSMP_MP,
                FormName.MediaPlan,
                EndpointTypes.DeleteEntity,
                null,
                null,
                entityGuids
              );

              this._subscriptions.push(
                this._rtsBackendService
                  .fetchMediaPlanSettings(payload)
                  .subscribe(result => {
                    this.openServiceError(result);
                    this._notificationService.openNoty('Uspešno brisanje');
                    this.loadSettings();
                    this._spinner.hide();
                  })
              );
            } else {
              this._spinner.hide();
            }
          }
        );
      } else {
        this.notifyError(
          `Brisanje media plana nije moguće, rezervacije nisu u statusu 'Slobodna'`
        );
        this._spinner.hide();
      }
    });
  }

  onSave() {
    this.isModeAdd ? this.addOrder() : this.updateOrder();
  }

  onToolbarAction(event: ToolbarAction) {
    switch (event) {
      case ToolbarAction.Close:
        this.onClose();
        break;

      case ToolbarAction.Delete:
        this.onDelete(null, this.onDeleteConfirm.bind(this));
        break;

      case ToolbarAction.Save:
        this.onSave();
        break;

      case ToolbarAction.Cancel:
        this.onCancel();

        this.rezervacije = [];
        this._sveRezervacije = [];
        break;

      case ToolbarAction.Edit:
        this.onEdit();
        break;

      case ToolbarAction.Add:
        this.order = {};
        this.rezervacije = [];
        this._sveRezervacije = [];
        this.resetFilter();
        this.onTableActionAdd();
        break;
    }
  }

  resetFilter() {
    this.primeniDatumNaRezervacije = false;
    this.programFilter = false;
    this.ukljuciIzabraniSpot = false;
  }

  onTableActionUpdate(event: TableActionParams) {
    super.onTableActionUpdate(event);
    this.refreshTable();
  }

  addOrder() {
    if (!this._sveRezervacije || !this._sveRezervacije.length) {
      this._notificationService.notyError(
        'Potrebno je dodati bar jednu rezervaciju.'
      );

      return;
    }

    this._spinner.show();

    const entity = {
      KupacId: this.selectedPodugovorKlijent.KlijentId,
      KupacNaziv: this.selectedPodugovorKlijent.KlijentNaziv,
      BrojPodugovora: this.selectedPodugovorKlijent.BrojPodugovora,
      PodugovorId: this.selectedPodugovorKlijent.PodugovorId,
      TipPodugovoraId: this.selectedPodugovorKlijent.TipUgovoraId,
      KupacJePravnoLice: !this.selectedUgovor.KlijentMaticniBroj,
      UgovorId: this.selectedUgovor.Id,
      BrojUgovora: this.selectedUgovor.BrojUgovora,
      ProgramId: this.selectedProgram.Id,
      ProgramNaziv: this.selectedProgram.Naziv,
      Rezervacije: this.rezervacije,
      DatumOd: this.order.DatumOd,
      DatumDo: this.order.DatumDo,
    };

    const entityGuids = {
      KupacId: entity.KupacId,
      UgovorId: entity.UgovorId,
      PodugovorId: entity.PodugovorId,
    };

    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSMP_MP,
      FormName.MediaPlan,
      EndpointTypes.PostEntity,
      null,
      entity,
      entityGuids
    );

    this._subscriptions.push(
      this._rtsBackendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          this._spinner.hide();

          if (this.hasError(response)) {
            this.notifyError(response['Errors'][0]['ErrorMessage']);

            return;
          }

          if (this.isMediaPlanExpanded(response, entity)) {
            this._notificationService.openNoty(
              `Postojeći medija plan sa brojem ugovora ${entity.BrojUgovora} za klijenta ${entity.KupacNaziv} je proširen.`
            );
          }

          this.resetForm();
          this.loadSettings();
          this._notificationService.openNoty('Uspešno sačuvan media plan.');
        })
    );
  }

  isMediaPlanExpanded(response, entity) {
    return (
      moment(response.ServiceData.DatumOd).isBefore(entity.DatumOd) ||
      moment(response.ServiceData.DatumDo).isAfter(entity.DatumDo) ||
      (response.ServiceData.Rezervacije &&
        response.ServiceData.Rezervacije.length > entity.Rezervacije.length)
    );
  }

  updateOrder() {
    if (!this._sveRezervacije || !this._sveRezervacije.length) {
      this._notificationService.notyError(
        'Potrebno je dodati bar jednu rezervaciju.'
      );

      return;
    }

    this._spinner.show();

    const entity = {
      KupacId: this.selectedUgovor.KupacId,
      UgovorId: this.selectedUgovor.UgovorId,
      PodugovorId: this.order.PodugovorId,
      Rezervacije: this._sveRezervacije,
      DatumOd: this.order.DatumOd,
      DatumDo: this.order.DatumDo,
      TipPodugovoraId: this.selectedPodugovorKlijent.TipUgovoraId,
      NacinObracunaId: this.selectedPodugovorKlijent.NacinObracunaId,
    };

    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSMP_MP,
      FormName.MediaPlan,
      EndpointTypes.PutEntity,
      null,
      entity,
      null
    );

    this._subscriptions.push(
      this._rtsBackendService
        .fetchMediaPlanSettings(payload)
        .subscribe(response => {
          this._spinner.hide();

          if (this.hasError(response)) {
            this.notifyError(response['Errors'][0]['ErrorMessage']);
            this.vratiObrisaneRezervacije();

            return;
          }

          this.resetForm();
          this.loadSettings();
          this._notificationService.openNoty('Uspešno ažuriran media plan.');
        })
    );
  }

  vratiObrisaneRezervacije() {
    if (this._sveRezervacije.some(x => x.Deleted)) {
      this._sveRezervacije.forEach(x => {
        x.Deleted = false;
      });

      this.rezervacije = this._sveRezervacije;
    }
  }

  hasError(response: any) {
    return (
      response['Errors'] &&
      response['Errors'].length &&
      response['Errors'][0]['ErrorMessage']
    );
  }

  resetForm() {
    this.selectedUgovor = null;
    this.selectedSpot = null;
    this.selectedEmisija = null;
    this.selectedPodugovorKlijent = null;
    this.dnevnoSelected = false;
    this.rezervacije = [];
  }

  resetData() {
    this.rezervacije = [];
    this._sveRezervacije = [];
    this.emisijeList = [];
    this.spotoviList = [];
    this.rasporediList = [];
    this.rasporediBrojRezervacija = [];
  }

  fetchMediaPlanSettings(mode: FormModeEnum) {
    this.setInitKlijentiNaUgovoruFilter();
    this.resetData();

    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSMP_MP,
      FormName.MediaPlan,
      EndpointTypes.GetModelData
    );

    this._subscriptions.push(
      this._rtsBackendService
        .fetchMediaPlanSettings(payload)
        .subscribe(data => {
          this.changeMode(mode);
          this.setDetailsSettings(data);
        })
    );
  }

  onPodugovorChange(event: any) {
    if(!event.Podugovor) {
      this.selectedPodugovorKlijent = null;
      return;
    }

    this.selectedPodugovorKlijent = event.Podugovor;
    this._klijentZaRezervacije = this.getKlijentFromObjects(
      this.selectedPodugovorKlijent,
      this.order
    );

    this.setDatumiZaUgovorPoPaketu();
    this.spotoviList = [];
    if (event.Spotovi.length) {
      this.fetchSpotovi(
        event.Spotovi,
        event.program.VrstaMedijaId,
        event.Podugovor.PodugovorId
      );
    } else {
      this.refreshTableByType(this.spotoviList, 'spotovi');
      this.selectedSpot = null;
    }

    this.onFetchEmisije(event);
  }

  selectUgovorConfirmation(event) {
    if(event.ugovor.ImaAnekse !== null || event.ugovor.ImaAnekse !== undefined) {
      return `${event.ugovor.BrojUgovora} ima anekse, da li ste sigurni da želite njega da selektujete?`;
    }
  }

  onUgovorChange(event: any) {
      if(event.ugovor.ImaAnekse && event.ugovor.ImaMediaPlan) {
        this._modalService.openModal(
          this.selectUgovorConfirmation(event),
          response => {
            if (response) {
              this.selectedUgovor = event.ugovor;
            }
            else {
              this.selectedUgovor = null;
            }
          }
        );
      }
      else {
        this.selectedUgovor = event.ugovor;
      }
  }

  onPregled(event: any) {
    this.resetTables();

    const ugovor = event.ugovor;

    if (ugovor) {
      const ugovorId = ugovor.Id || ugovor.UgovorId;

      if (this.isUgovorChanged(ugovorId, event.podugovor.PodugovorId)) {
        this.rezervacije = [];
      }

      this.fetchMediaPlanData(
        ugovor,
        event.podugovor.Spotovi,
        event.program.VrstaMedijaId,
        event.podugovor.PodugovorId
      );
    }

    this.selectedPodugovorKlijent = event.podugovor;
    this.selectedProgram = event.program;

    if (
      this.selectedPodugovorKlijent.TipUgovoraId ===
      this.ugovorZaSponzorstvoTipId
    ) {
      this.getEmisijePodugovor(
        this.selectedPodugovorKlijent.PodugovorId
      ).subscribe(res => {
        this.selectedPodugovorKlijent.Emisije = res.ServiceData;
      });
    }

    if (this.mode !== FormModeEnum.Add) {
      this.setRezervacije(event);
    }

    this._klijentZaRezervacije = this.getKlijentFromObjects(
      this.selectedPodugovorKlijent,
      this.order
    );

    this.onFetchEmisije(event);
    // this.fetchSpotovi(
    //   event.podugovor.Spotovi,
    //   event.program.VrstaMedijaId,
    //   event.podugovor.PodugovorId
    // );
  }

  setDatumiZaUgovorPoPaketu() {
    if (
      this.selectedPodugovorKlijent.TipUgovoraId ===
      this.getUgovorPoPaketuTipId()
    ) {
      this.order.DatumDo = this.selectedPodugovorKlijent.DatumIsteka;
      this.order.DatumOd = this.selectedPodugovorKlijent.DatumKreiranja;
    }
  }

  resetTables() {
    this.selectedSpot = null;
    this.selectedEmisija = null;
    this.selectedRaspored = null;

    if (this.rasporediList.length) {
      this.rasporediList = [];
      this._rasporediListSource.next(this.rasporediList);
    }
  }

  isUgovorChanged(ugovorId: any, podugovorId: any) {
    return (
      this.selectedUgovor &&
      this.selectedPodugovorKlijent &&
      (ugovorId !==
        (this.selectedUgovor.UgovorId
          ? this.selectedUgovor.UgovorId
          : this.selectedUgovor.Id) ||
        podugovorId !== this.selectedPodugovorKlijent.PodugovorId)
    );
  }

  onDatumChanged(event) {
    this.order.DatumOd = event.datumOd;
    this.order.DatumDo = event.datumDo;
  }

  fetchMediaPlanData(
    ugovor: any,
    spotIds: any[],
    vrstaMedijaId: number,
    podugovorId: string
  ) {
    this.selectedUgovor = ugovor;

    if (spotIds && spotIds.length) {
      this.fetchSpotovi(spotIds, vrstaMedijaId, podugovorId);
    } else {
      this.refreshTableByType([], 'spotovi');
    }
  }

  fetchSpotovi(
    spotIds: Array<any>,
    vrstaMedijaId: number,
    podugovorId: string,
    checkVs: string = null
  ) {
    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSSPO_SPOID,
      FormName.MediaPlan,
      EndpointTypes.PostEntity,
      `?vrstaMedijaId=${vrstaMedijaId}`,
      spotIds.map(s => s.SpotId),
      null,
      true
    );

    this._subscriptions.push(
      this._rtsBackendService
        .fetchMediaPlanSettings(payload)
        .subscribe((data: any) => {
          this._spinner.hide();
          const spotovi = data.ServiceData ? data.ServiceData : [];
          this.mapZeljenaPozicija(spotovi, spotIds);
          this.setSpotovi(spotovi, podugovorId);
        })
    );
  }

  setSpotovi(spotovi, podugovorId) {
    this.setId(spotovi);
    this.setSpotColor(spotovi);
    this._sviSpotovi = spotovi;
    const obs = of(this._sviSpotovi);
    obs.subscribe(() => {
      const obs2 = of(this.setSpotRezervacijeEmisije(podugovorId));
      obs2.subscribe(() => {
        spotovi = this.prikaziSveSpotove
          ? spotovi
          : spotovi.filter(s => !s.JeIstekao);

        this.refreshTableByType(spotovi, 'spotovi');
      });
    });
  }

  mapZeljenaPozicija(spotovi, ugopugSpotovi) {
    spotovi.forEach(
      x =>
        (x.ZeljenaPozicija = ugopugSpotovi.find(
          y => y.SpotId === x.Id
        ).ZeljenaPozicija)
    );
  }

  setSpotColor(spotovi) {
    spotovi.forEach(s => {
      s.color = s.JeIstekao ? 'danger' : '';
    });
  }

  filterSpotovi() {
    this.prikaziSveSpotove = !this.prikaziSveSpotove;
    this.spotoviList = this.prikaziSveSpotove
      ? [...this._sviSpotovi]
      : this._sviSpotovi.filter(s => !s.JeIstekao);
    this.setSpotColor(this.spotoviList);
    this.setId(this.spotoviList);
  }

  filterEmisije(value) {
    if (value == 0) {
      this.prikaziEmisijePre18 = !this.prikaziEmisijePre18;
    } else if (value == 1) {
      this.prikaziEmisijePosle18 = !this.prikaziEmisijePosle18;
    }
    if (this.emisijeList != null) {
      if (!this.prikaziEmisijePre18 && !this.prikaziEmisijePosle18) {
        this.emisijeFilteredList = this.emisijeList;
      } else if (this.prikaziEmisijePre18 && !this.prikaziEmisijePosle18) {
        this.emisijeFilteredList = this.emisijeList.filter(a => a.VremeEmitovanja != null && a.VremeEmitovanja.length > 3 && a.VremeEmitovanja.substring(0, 2) < 18 && a.VremeEmitovanja.substring(0, 2) > 5);
      } else if (!this.prikaziEmisijePre18 && this.prikaziEmisijePosle18) {
        this.emisijeFilteredList = this.emisijeList.filter(a => a.VremeEmitovanja != null && a.VremeEmitovanja.length > 3 && (a.VremeEmitovanja.substring(0, 2) >= 18 || a.VremeEmitovanja.substring(0, 2) < 6));
      } else {
        this.emisijeFilteredList = [];
      }
      this.refreshTableByType(this.emisijeFilteredList, 'emisijeFiltered');
    }
  }

  fetchEmisije() {
    const entityGuids = {
      ProgramId: this.selectedProgram ? this.selectedProgram.Id : null,
    };

    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSEMI_EMI,
      FormName.MediaPlan,
      EndpointTypes.GetAllEntities,
      this._emisijaFilter,
      null,
      entityGuids
    );

    this._subscriptions.push(
      this._rtsBackendService
        .fetchMediaPlanSettings(payload)
        .subscribe(response => {
          this._spinner.hide();
          this.emisijeFilteredList = response['ServiceData']['Data'];
          this.refreshTableByType(this.emisijeFilteredList, 'emisije');

          if (this.emisijeFilteredList.length) {
            this.setDefaultEmisija(this.emisijeFilteredList[0]);
            if (this.selectedPodugovorKlijent) {
              this.setBrSpotovaNaEmisiji();
            }
          }
        })
    );
  }

  getEmisijePodugovor(podugovorId): Observable<any> {
    const entityGuids = {
      PodugovorId: podugovorId,
    };

    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSUGO_EMIPUG,
      FormName.PregledEmisija,
      EndpointTypes.GetAllEntities,
      `?podugovorId=${podugovorId}`,
      null,
      null,
      true
    );

    return this._rtsBackendService.fetchMediaPlanSettings(payload);
  }

  setDefaultEmisija(emisija: any) {
    const fakeEvent = { action: 'select', document: emisija };
    setTimeout(() => {
      this.emisijeTableAction(fakeEvent);
      this.selectEmisijaSource.next(emisija);
    }, 100);
  }

  onFetchEmisije(event: any) {
    this.selectedProgram = event.program;

    this._emisijaFilter = this.getEmisijaFilterQuery();
    this.fetchEmisije();
  }

  getEmisijaFilterQuery() {
    const datumOd = this.order.DatumOd
      ? moment(this.order.DatumOd).format(DEFAULT_DATE_FORMAT)
      : moment()
          .startOf('month')
          .format(DEFAULT_DATE_FORMAT);

    const datumDo = this.order.DatumDo
      ? moment(this.order.DatumDo).format(DEFAULT_DATE_FORMAT)
      : moment(datumOd)
          .endOf('month')
          .format(DEFAULT_DATE_FORMAT);

    const datumPocetka = `datumPocetkaEmitovanja=${datumOd}`;
    const datumZavrsetkaEmitovanja = `datumZavrsetkaEmitovanja=${datumDo}`;

    let filterQuery = `?${datumPocetka}&${datumZavrsetkaEmitovanja}&extendedModel=true&programId=${this.selectedProgram.Id}&order=VremeEmitovanja&orderDirection=Asc`;

    if (
      this.selectedPodugovorKlijent &&
      this.selectedPodugovorKlijent.TipUgovoraId ===
        this.ugovorZaSponzorstvoTipId
    ) {
      filterQuery = `${filterQuery}&podugovorId=${this.selectedPodugovorKlijent.PodugovorId}`;
    }

    return filterQuery;
  }

  obrisi() {
    const selectedRezervacije = this.rezervacije.filter(r => r.selected);

    if (!selectedRezervacije || !selectedRezervacije.length) {
      this._notificationService.openNoty(
        `Niste izabrali rezarvacije za brisanje.`
      );

      return;
    }

    selectedRezervacije.forEach(r => {
      const index = this._sveRezervacije.findIndex(
        x =>
          x.EmisijaRasporedId === r.EmisijaRasporedId && x.SpotId === r.SpotId
      );

      this._sveRezervacije.splice(index, 1);

      const emisija = this.emisijeList.find(e => e.Id === r.EmisijaId);
      const raspored = emisija.Rasporedi.find(
        a => a.Id === r.EmisijaRasporedId
      );

      raspored.Preostalo = raspored.Preostalo + r.SpotTrajanje;
      raspored.Zauzeto = raspored.Zauzeto - r.SpotTrajanje;
    });

    this.rezervacije = this.rezervacije.filter(r => !r.selected);

    if (this.rasporediList.length) {
      this._rasporediListSource.next(this.rasporediList);
      this.selectAddedRasporedi();
      if (this.selectedSpot) {
        this.checkToggles();
      }
    }

    this.allRezervacijeSelected = false;
  }

  // metoda je deo stare logike za pronalazenje obrisanih rezervacija.
  obrisi_old() {
    const selectedRezervacije = this.rezervacije.filter(r => r.selected);

    if (!selectedRezervacije || !selectedRezervacije.length) {
      this._notificationService.openNoty(
        `Niste izabrali rezarvacije za brisanje.`
      );

      return;
    }

    this.emisijeList.forEach(emisija => {
      emisija.Rasporedi.forEach(raspored => {
        const deletedRezervacija = selectedRezervacije.find(
          sr => sr.EmisijaRasporedId === raspored.Id
        );

        if (deletedRezervacija) {
          const foundSpot = this.spotoviList.find(
            spot => spot.Id === deletedRezervacija.SpotId
          );

          if (!foundSpot) {
            return;
          }

          const trajanje = foundSpot.TrajanjeSekunde;
          const rezIndex = this._sveRezervacije.findIndex(
            r =>
              r.EmisijaRasporedId === deletedRezervacija.EmisijaRasporedId &&
              r.SpotId === deletedRezervacija.SpotId
          );

          raspored.Zauzeto = raspored.Zauzeto - trajanje;
          raspored.Preostalo = raspored.Preostalo - raspored.Zauzeto;
          this._sveRezervacije.splice(rezIndex, 1);

          // const index = this._deletedRezervacije.findIndex(
          //   rezervacija =>
          //     rezervacija.RasporedId === deletedRezervacija.RasporedId
          // );

          // if (index !== -1) {
          //   this._deletedRezervacije.splice(index, 1);
          // }
        }
      });
    });

    // this._deletedRezervacije = [
    //   ...this._deletedRezervacije,
    //   ...selectedRezervacije,
    // ];

    this.rezervacije = this.rezervacije.filter(r => !r.selected);
    // this._sveRezervacije.forEach(sve => {
    //   if (
    //     this._deletedRezervacije.filter(deleted => sve.Id === deleted.Id)
    //       .length > 0
    //   ) {
    //     sve.Deleted = true;
    //   } else {
    //     sve.Deleted = false;
    //   }
    // });

    if (this.rasporediList.length) {
      this._rasporediListSource.next(this.rasporediList);
      this.selectAddedRasporedi();
      if (this.selectedSpot) {
        this.checkToggles();
      }
    }

    this.allRezervacijeSelected = false;
  }

  filterRezervacijeToAddByDateAndProgram(rasporedi: any[]) {
    if (this.selectedProgram && this.selectedProgram.VrstaMedijaId === 1) {
      const today = moment().format(DEFAULT_DATE_FORMAT);
      const toCreate = rasporedi.filter(r =>
        moment(r.DatumEmitovanja).isSameOrAfter(moment(today))
      );

      const notCreated: any[] = rasporedi.filter(r =>
        moment(r.DatumEmitovanja).isBefore(today)
      );

      if (notCreated.length > 0) {
        this._notificationService.notyError(
          `TV Rezervacije čiji je datum emtiovanja u prošlosti nije moguće kreirati. ${
            toCreate.length > 0
              ? 'Ostale TV rezervacije su uspešno kreirane.'
              : ''
          }`
        );
      }

      return toCreate;
    }

    return rasporedi;
  }

  onTableMode() {
    super.onTableMode();
    this.showDetails = false;
    this.resetForm();
    this.resetData();
  }

  onAddMode() {
    this.resetFilter();
    this.setToolbarOptions({
      toolbarVisible: true,
      items: [
        ToolbarItem.ItemSave(
          true,
          true,
          'Dugme "Sačuvaj" služi za čuvanje podataka o Media planu.'
        ),
      ],
      closeTooltip: 'Dugme "X" služi za poništavanje unosa.',
    });

    this.order = {};
    this.order = {
      DatumOd: moment()
        .startOf('month')
        .format(DEFAULT_DATE_FORMAT),
      DatumDo: moment()
        .endOf('month')
        .format(DEFAULT_DATE_FORMAT),
    };

    const defProgram = this.programi.find(p => p.Naziv === 'RTS1 TV');
    this.defaultProgramId = defProgram.Id;
    this._mediaPlanService.setProgram(this.defaultProgramId);
    this.selectedProgram = defProgram;

    this.getEmisijaFilterQuery();
    this.fetchEmisije();

    this.showDetails = true;
  }

  canDeleteMediaPlan(): Observable<any> {
    const entityGuids = {
      UgovorId: this.order.UgovorId,
      KupacId: this.order.KupacId,
      PodugovorId: this.order.PodugovorId,
    };

    return this._rtsBackendService.fetchMediaPlanSettings(
      this._rtsBackendService.getRequestPayload(
        FormCode.MSMP_PBRI,
        FormName.MediaPlan,
        EndpointTypes.SingleEntity,
        null,
        null,
        entityGuids
      )
    );
  }

  resetToggles() {
    this.dnevnoSelected = false;
    this.nedeljnoSelected = false;
    this.mesecnoSelected = false;
    this.radniDaniSelected = false;
    this.vikendiSelected = false;
  }

  onClose() {
    this._spinner.show();
    this.rezervacije = [];
    this._sveRezervacije = [];
    this.emisijeFilteredList = [];
    this.prikaziSveSpotove = false;
    this.prikaziEmisijePosle18 = false;
    this.prikaziEmisijePre18 = false;
    this.resetToggles();
    super.onClose();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/media-plan/media-plan.component.ts